export const toTitleCase = (str) => {
    return str.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

export const capitalize = (str) => {
    return str.toUpperCase();
}


// WEBPACK FOOTER //
// ./src/utils/textTransform.js